const INPUT_TAG_DELIMETER = ',';

export { INPUT_TAG_DELIMETER };
